<script>
import Rate from 'element-ui/lib/rate';

export default Rate;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/rate.css';

.el-rate {
  direction: ltr;

  &__item,
  &__text {
    vertical-align: baseline;
  }

  &__icon {
    // limiting the animated properties
    transition-property: color, transform;
  }
}
</style>
